import React from 'react'
import VideoPlayer from '../components/VideoPlayer'

function Player() {
  return (
    <>
      <div>Player</div>
      <VideoPlayer />
    </>
  )
}

export default Player